/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PageMetadata } from './page-metadata';
import { ServizioMensaStudenteReportDTO } from './servizio-mensa-studente-report-dto';


export interface PagedModelServizioMensaStudenteReportDTO { 
    content?: Array<ServizioMensaStudenteReportDTO>;
    page?: PageMetadata;
}

